import service from '@/services/modules/portal/frm_libro_reclamacion'

export default {
  FRM_LIBRO_RECLAMACION_FIND_ALL(_, params) {
    return new Promise((resolve, reject) => {
      service.findAll(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  FRM_LIBRO_RECLAMACION_UPDATE(_, params) {
    return new Promise((resolve, reject) => {
      service.updateStatus(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
}
